import clsx from 'clsx'
import { format } from 'date-fns'

import style from './FilesList.module.css'

const FileModalItem = ({ file, selected, onSelect }: { file: any; selected: boolean; onSelect: () => void }) => {
  let formattedDate = 'Unknown date'
  try {
    const timestamp = Math.floor(file.modified * 1000)
    if (!isNaN(timestamp) && timestamp > 0) {
      formattedDate = format(new Date(timestamp), 'dd.MM.yyyy HH:mm')
    }
  } catch (e) {
    console.warn('Invalid date for file:', file.name, e)
  }

  const displayName = file.name ? file.name.replace(/\.[^/.]+$/, '') : 'Unnamed file'

  return (
    <div className={selected ? clsx(style.tableItem, style.selected) : style.tableItem} onClick={onSelect}>
      <span>{displayName}</span>
      <span>{formattedDate}</span>
    </div>
  )
}

const FilesList = ({
  files,
  selectedFile,
  onSelect,
  onScrollBottom,
}: {
  files: any[]
  selectedFile: any
  onSelect: (file: any) => void
  onScrollBottom?: () => void
}) => {
  if (!Array.isArray(files)) {
    return <p>Loading files... </p>
  }

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      onScrollBottom?.()
    }
  }

  return (
    <>
      <div className={style.tableHeader}>
        <span>Name</span>
        <span>Created at</span>
      </div>
      <div className={style.table} onScroll={handleScroll}>
        {files.map(file => (
          <FileModalItem
            key={file.id || file.name}
            file={file}
            selected={file?.id === selectedFile?.id && file?.name === selectedFile?.name}
            onSelect={() => onSelect(file)}
          />
        ))}
      </div>
    </>
  )
}

export default FilesList
